module.exports = __webpack_public_path__ + "img/IMG_9934-43_P_L.79378c8a.webp";